import { createFeatureSelector } from '@ngrx/store';
import { FILTERS_FEATURE_NAME } from '~app/modules/filters/store/feature-name';

export const getFiltersModuleState = createFeatureSelector(FILTERS_FEATURE_NAME);
